import { Component, OnInit, Input } from '@angular/core';
import { NavbarItems } from '../../utilities/navigation-pills-settings';

@Component({
  selector: 'fgb-navigation-pills',
  templateUrl: './navigation-pills.component.html',
  styleUrls: ['./navigation-pills.component.scss'],
})
export class NavigationPillsComponent implements OnInit {
  @Input() navItems: NavbarItems[];

  ngOnInit() {}
}
